import { format } from "date-fns";

// Backend timestamps are UTC (DateTime.UtcNow) but the serialized string can lack a
// timezone marker after the EF round-trip; JS would then parse it as local time and
// show the UTC wall-clock. Treat a marker-less value as UTC so callers render in the
// browser's local timezone (with the correct DST offset). Returns null for
// null/blank/unparseable values so callers can hide the field gracefully.
export function parseUtcDate(value?: string | null): Date | null {
  if (!value) return null;
  const hasTz = /[Zz]$|[+-]\d\d:?\d\d$/.test(value);
  const iso = hasTz ? value : value + "Z";
  const date = new Date(iso);
  return isNaN(date.getTime()) ? null : date;
}

export function formatUtcLocal(value?: string | null): string {
  const date = parseUtcDate(value);
  return date ? date.toLocaleString() : "";
}

// Renders a UTC timestamp in the browser's local timezone using a date-fns pattern.
// Returns "" for null/blank/unparseable values so callers can hide the field.
export function formatUtcLocalPattern(
  value?: string | null,
  pattern = "M/d/yyyy h:mm a"
): string {
  const date = parseUtcDate(value);
  return date ? format(date, pattern) : "";
}
